const Roles = () => (
  <div>
    <h2>Roles</h2>
  </div>
);

export default Roles;
